import React, { useState } from 'react';
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';

import ArticulosDestacadosModalTable from './ArticulosDestacadosModalTable.js';


const ArticulosModal = (props) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const ArticulosDestacadosChanged = (id, added) => {
       let articulos = props.articulos.filter(item=>item!=id);
       if(added == true) articulos.push(id);
       props.onChangeField("articulos", articulos);
  };
  return (
    <div>
      <Button color="info" className="w-100" onClick={toggle}>Ver Artículos</Button>
      <Modal isOpen={modal} toggle={toggle} className="modal-xl">
      <ModalHeader toggle={toggle}>Articulos</ModalHeader>
        <ModalBody>
        <ArticulosDestacadosModalTable
        disabled={props.vars.disabled}
        ChangeAllDataSet={(articulos)=>props.onChangeField("articulos", articulos)}
        ArticulosDestacadosChanged={ArticulosDestacadosChanged}
        articulos={props.articulos}
        />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cerrar</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ArticulosModal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Destacados/ArticulosModal.js